import { createContext, useContext } from "react";

/** Device type id -> { type, label, icon, category, metadata }. */
export const DeviceTypesContext = createContext(null);

export function useDeviceTypes() {
  return useContext(DeviceTypesContext);
}

/** Resolve label/icon: API map first, then topology.config fallback. */
export function getDeviceTypeDisplay(type, deviceTypesMap, getNodeTypeConfig) {
  const fromApi = deviceTypesMap?.get?.(type) ?? deviceTypesMap?.[type];
  if (fromApi) {
    const fallbackIcon = getNodeTypeConfig?.("custom_device")?.icon;
    return {
      label: fromApi.label ?? fromApi.name ?? type,
      icon: fromApi.icon || fallbackIcon,
    };
  }
  const fromConfig = getNodeTypeConfig?.(type);
  if (fromConfig) {
    return {
      label: fromConfig.defaultLabel ?? type,
      icon: fromConfig.icon,
    };
  }
  return { label: type, icon: undefined };
}
